'use strict'

if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  require('promise/lib/rejection-tracking').enable()
  window.Promise = require('promise/lib/es6-extensions.js')
}

// fetch() polyfill for making API calls.
require('whatwg-fetch')

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = require('object-assign')

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (process.env.NODE_ENV === 'test') {
  require('raf').polyfill(global)

  const storageMock = () => {
    let storage = {}
    return {
      getItem: key => (key in storage ? storage[key] : null),
      setItem: (key, value) => {
        storage[key] = value ? value.toString() : ''
      },
      removeItem: key => {
        delete storage[key]
      },
      clear: () => {
        storage = {}
      },
    }
  }

  if (typeof global.sessionStorage === 'undefined') {
    global.sessionStorage = storageMock()
  }
  if (typeof global.localStorage === 'undefined') {
    global.localStorage = storageMock()
  }
  if (typeof window !== 'undefined') {
    if (typeof window.sessionStorage === 'undefined') {
      window.sessionStorage = global.sessionStorage
    }
    if (typeof window.localStorage === 'undefined') {
      window.localStorage = global.localStorage
    }
  }
}



//////////////////
// WEBPACK FOOTER
// ./config/polyfills.js
// module id = ./config/polyfills.js
// module chunks = 0